import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KlevuSearchModule } from '@df/module-klevu-search/klevu-search.module';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { ProductCollectionStateComponent } from '../branch/product-collection-state/product-collection-state.component';
import { SearchBannerComponent } from '../page/search/banner/search-banner.component';
import { ProductDeliveryStateComponent } from '../product-delivery-state/product-delivery-state.component';
import { SharedModule } from '../shared.module';
import { SwatchComponent } from './attribute/swatch/swatch.component';
import { MultiFileUploadComponent } from './customform/components/multi-file-upload.component';
import { SingleFileUploadComponent } from './customform/components/single-file-upload.component';
import { CustomformComponent } from './customform/customform.component';
import { ProductListingDropdownComponent } from './listing/dropdown/listing-dropdown.component';
import { FilterAttributeDropdownComponent } from './listing/filter/filter-attribute-dropdown/filter-attribute-dropdown.component';
import { FilterCategoryComponent } from './listing/filter/filter-category.component';
import { FilterPageBlogTagComponent } from './listing/filter/filter-page-blog-tag.component';
import { FilterQueryComponent } from './listing/filter/filter-query.component';
import { FiltersComponent } from './listing/filters.component';
import { ProductListingFiltersModalComponent } from './listing/product-listing-filters.modal.component';
import { ProductListingToolsComponent } from './listing/product-listing-tools.component';
import { ProductListingComponent } from './listing/product-listing.component';
import { ListingSizeComponent } from './listing/size/listing-size.component';
import { ListingSortComponent } from './listing/sort/listing-sort.component';
import { BreadcrumbsComponent } from './meta/breadcrumbs.component';
import { ProductAddToBasketComponent } from './product/add-to-basket/product-add-to-basket.component';
import { ProductAltImageComponent } from './product/alt-image/product-alt-image.component';
import { CmsProductDeliveryComponent } from './product/cms/delivery/cms-product-delivery.component';
import { CmsProductReviewsComponent } from './product/cms/product-reviews/cms-product-reviews.component';
import { CmsProductSizeGuideComponent } from './product/cms/product-size-guide/cms-product-size-guide.component';
import { CmsSizeGuideTableComponent } from './product/cms/product-size-guide/table/cms-size-guide-table.component';
import { ProductPriceComponent } from './product/price/product-price.component';
import { ProductImageLabelComponent } from './product/product-image-label/product-image-label.component';
import { ProductPromoBarComponent } from './product/product-promo-bar/product-promo-bar.component';
import { ProductQtyComponent } from './product/product-qty/product-qty.component';
import { ProductComponent } from './product/product/product.component';
import { ProductReviewsSummaryComponent } from './product/reviews-summary/product-reviews-summary.component';
import { SimpleProductComponent } from './product/simple-product/simple-product.component';
import { SimpleRelatedProductsComponent } from './product/simple-related-products/simple-related-products.component';
import { ProductWishlistToggleComponent } from './product/wishlist-toggle/product-wishlist-toggle.component';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        ProductCollectionStateComponent,
        ProductDeliveryStateComponent,
        KlevuSearchModule,
        ProductPromoBarComponent,
        ProductImageLabelComponent,
        MultiFileUploadComponent,
        SingleFileUploadComponent
    ],
    declarations: [
        SwatchComponent,
        CustomformComponent,
        CmsProductDeliveryComponent,
        BreadcrumbsComponent,
        CmsProductReviewsComponent,
        CmsProductSizeGuideComponent,
        CmsSizeGuideTableComponent,
        FilterAttributeDropdownComponent,

        FiltersComponent,
        FilterCategoryComponent,
        FilterPageBlogTagComponent,
        FilterQueryComponent,
        ProductAddToBasketComponent,
        ListingSizeComponent,
        ListingSortComponent,
        ProductAltImageComponent,
        ProductPriceComponent,
        ProductComponent,
        ProductQtyComponent,
        ProductReviewsSummaryComponent,
        ProductWishlistToggleComponent,
        ProductListingComponent,
        ProductListingDropdownComponent,
        ProductListingFiltersModalComponent,
        ProductListingToolsComponent,
        SimpleProductComponent,
        SimpleRelatedProductsComponent,
        SearchBannerComponent
    ],
    exports: [
        SwatchComponent,
        CustomformComponent,
        BreadcrumbsComponent,
        CmsProductDeliveryComponent,
        CmsProductReviewsComponent,
        CmsProductSizeGuideComponent,
        CmsSizeGuideTableComponent,
        FilterCategoryComponent,
        FilterPageBlogTagComponent,
        ProductAddToBasketComponent,
        ProductCollectionStateComponent,
        ProductDeliveryStateComponent,
        FilterQueryComponent,
        ListingSizeComponent,
        ListingSortComponent,
        ProductImageLabelComponent,
        ProductPriceComponent,
        ProductComponent,
        ProductReviewsSummaryComponent,
        ProductWishlistToggleComponent,
        ProductListingComponent,
        ProductListingFiltersModalComponent,
        ProductListingToolsComponent,
        SimpleProductComponent,
        SimpleRelatedProductsComponent,
        SearchBannerComponent
    ]
})
export class CatalogCommonModule {
    constructor() {
        surviveTreeShaking(ProductListingFiltersModalComponent);
    }
}
